import { select, useDispatch } from '@ps/web-core-store';
import type React from 'react';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';

const SpadeEmbeddedAPIProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
  const { modal } = useDispatch();
  const { idpToken } = useSelector(select.session.get);
  const isAuthenticated = useSelector(select.session.isAuthenticated);

  useEffect(() => {
    const subscriptions = [
      window.Spade?.api?.on('login', () => {
        if (!isAuthenticated) modal.enqueue({ path: '/auth/login' });
      })
    ];

    return () => {
      subscriptions.forEach((subscription) => subscription?.off());
    };
  }, [modal, isAuthenticated]);

  useEffect(() => {
    if (idpToken) {
      window.Spade?.api?.setToken({ token: idpToken });
    }
  }, [idpToken]);

  return children;
};

export default SpadeEmbeddedAPIProvider;
